export default function IconPlus () {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.01453 3.98531C0.454223 3.98531 0 4.43953 0 4.99984C0 5.56016 0.454223 6.01438 1.01453 6.01438L3.98531 6.01438V8.98547C3.98531 9.54578 4.43953 10 4.99984 10C5.56016 10 6.01438 9.54578 6.01438 8.98547V6.01438H8.98547C9.54578 6.01438 10 5.56016 10 4.99985C10 4.43953 9.54578 3.98531 8.98547 3.98531H6.01438V1.01453C6.01438 0.454223 5.56016 1.14025e-06 4.99985 0C4.43953 1.14025e-06 3.98531 0.454223 3.98531 1.01453L3.98531 3.98531L1.01453 3.98531Z"
        fill="white"/>
    </svg>
  )
}
